import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Domains from "@/pages/Domains";
import HowItWorks from "@/pages/HowItWorks";
import ForStudents from "@/pages/ForStudents";
import Institutions from "@/pages/Institutions";
import Pricing from "@/pages/Pricing";
import SampleReport from "@/pages/SampleReport";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/Login";
import TakeTest from "@/pages/TakeTest";
import TestFlow from "@/pages/TestFlow";
import TestResult from "@/pages/TestResult";
import Checkout from "@/pages/Checkout";
import InstitutionDashboard from "@/pages/InstitutionDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/domains" element={<Domains />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/for-students" element={<ForStudents />} />
        <Route path="/institutions" element={<Institutions />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/sample-report" element={<SampleReport />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/take-test" element={<TakeTest />} />
        <Route path="/test" element={<TestFlow />} />
        <Route path="/test/result/:reportId" element={<TestResult />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/institution/dashboard" element={<InstitutionDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
